import { useEffect, useRef, useState } from "react";

const PARTIAL = /^-?\d*[.,]?\d*$/;
const show = (v) => (v === null || v === undefined || Number.isNaN(v) ? "" : String(v));

export const NumInput = ({ value, onChange, onBlur, step, min, max, className = "", ...rest }) => {
  const [text, setText] = useState(show(value));
  const focused = useRef(false);
  useEffect(() => { if (!focused.current || parseFloat(text) !== parseFloat(show(value))) setText(show(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const decimal = String(step || "").includes(".");
  const emit = (t, e) => {
    setText(t);
    if (t === "" || /^-?\d+([.,]\d+)?$/.test(t)) onChange?.({ ...e, target: { ...e.target, value: t.replace(",", ".") }, currentTarget: e.currentTarget });
  };
  const nudge = (dir, e) => {
    const n = (parseFloat(text) || 0) + dir * (parseFloat(step) || 1);
    const c = Math.min(max ?? Infinity, Math.max(min ?? -Infinity, n));
    emit(decimal ? c.toFixed(String(step).split(".")[1].length) : String(Math.round(c)), e);
  };
  return (
    <input {...rest} type="text" inputMode={decimal ? "decimal" : "numeric"} className={className} value={text} aria-valuemin={min} aria-valuemax={max}
      onFocus={(e) => { focused.current = true; rest.onFocus?.(e); }}
      onBlur={(e) => { focused.current = false; setText(show(value)); onBlur?.(e); }}
      onKeyDown={(e) => { if (e.key === "ArrowUp" || e.key === "ArrowDown") { e.preventDefault(); nudge(e.key === "ArrowUp" ? 1 : -1, e); } rest.onKeyDown?.(e); }}
      onChange={(e) => { const t = e.target.value.trim(); if (PARTIAL.test(t)) emit(t, e); }} />
  );
};
